import FaceIDIcon from './FaceIDIcon'

export default FaceIDIcon
